import initialState from './initialState'

const SET_COMMUNES = function(state, communes) {
    state.communes = communes
}

const SET_COMPANY_DATA = (state, data) => (state.companyData = data)

const SET_IS_TRANSBANK_INTEGRATED = (state, bool) => {
    state.isTransbankIntegrated = bool
    localStorage.setItem('transbank-integrated', bool)
}
const SET_HTML_PRINT = (state, bool) => {
    state.htmlPrint = bool
    localStorage.setItem('html-print', bool)
}
const SET_CUSTOMER_CREDIT_OPTIONS = (state, options) =>
    (state.customerCreditOptions = options)
const SET_PCH_PAYMENT_CONDITIONS = (state, array) =>
    (state.pchPaymentConditions = array)

/**
 * @description
 * Returns State to it's initial values
 * @param {*} state
 */
const RESET_STATE = function(state) {
    Object.assign(state, initialState())
}

export default {
    RESET_STATE,
    SET_COMMUNES,
    SET_IS_TRANSBANK_INTEGRATED,
    SET_COMPANY_DATA,
    SET_HTML_PRINT,
    SET_CUSTOMER_CREDIT_OPTIONS,
    SET_PCH_PAYMENT_CONDITIONS,
}
